import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';
import { detectPartnerPortal } from '../utils/portalMode.js';

const PortalContext = createContext();

export function usePortal() {
  const context = useContext(PortalContext);
  if (!context) {
    throw new Error('usePortal must be used within PortalProvider');
  }
  return context;
}

export function PortalProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const response = await api.get('/public/platform-settings');
        const data = response.data?.data || {};
        if (!cancelled) {
          setSettings(data);
        }
      } catch {
        if (!cancelled) {
          setSettings({});
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const partnerPortalHost = settings?.partnerPortalHost || '';
  const partnerPortalOrigin = settings?.partnerPortalOrigin || (
    partnerPortalHost ? `https://${partnerPortalHost}` : ''
  );
  const isPartnerPortal = detectPartnerPortal(
    typeof window !== 'undefined' ? window.location.hostname : '',
    partnerPortalHost,
  );

  return (
    <PortalContext.Provider
      value={{
        loading,
        settings,
        isPartnerPortal,
        partnerPortalHost,
        partnerPortalOrigin,
        refreshSettings: async () => {
          const response = await api.get('/public/platform-settings');
          const data = response.data?.data || {};
          setSettings(data);
          return data;
        },
      }}
    >
      {children}
    </PortalContext.Provider>
  );
}
